import { useEffect, useState } from "react";
import { useFetcher, useLoaderData } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { JDAReports } from "./JDAReports";
import { JDAReportsData, JDAReportsSectorKeys, Rating } from "./JDAReportsData";

export const JDAReportsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  return doFetch(`jda-reports/${params.sector ?? 'break-bulk'}`, { signal: request.signal }, true, false);
}

export const JDAReportsRoute = () => {
  const fetcher = useFetcher();
  const loaderData = useLoaderData();
  const data = fetcher.data as JDAReportsData ?? loaderData as JDAReportsData;
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [selectedSector, setSelectedSector] = useState<JDAReportsSectorKeys>('break-bulk');
  const [selectedJob, setSelectedJob] = useState<Rating>(data?.ratings[0]);
  const onShowDisclaimer = () => setShowDisclaimer(prev => !prev);

  useEffect(() => {
    if (data) {
      setSelectedJob(data.ratings[0])
    }
  }, [data]);

  const onSelectSector = (sector: JDAReportsSectorKeys) => {
    setSelectedSector(prev => prev !== sector ? sector : prev);
    if (sector !== selectedSector) {
      fetcher.load(`/jda-reports/${sector}`);
    }
  };

  const onSelectJob = (job: Rating | undefined) => {
    if (job) {
      setSelectedJob(job)
    }
  }

  return (
    <JDAReports
      data={data}
      onShowDisclaimer={onShowDisclaimer}
      showDisclaimer={showDisclaimer}
      sector={selectedSector}
      onSelectSector={onSelectSector}
      job={selectedJob}
      onSelectJob={onSelectJob}
    />
  )
}